var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAltCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "-0.45 -0.45 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03868608,3.06726912 C6.03868608,4.70873736 4.70873736,6.03868608 3.06726912,6.03868608 C1.42580088,6.03868608 0.09585216,4.70873736 0.09585216,3.06726912 C0.09585216,1.42580088 1.42580088,0.09585216 3.06726912,0.09585216 C4.70873736,0.09585216 6.03868608,1.42580088 6.03868608,3.06726912 Z M2.54008224,1.6774128 L2.54008224,3.06726912 L1.69059247,3.06726912 C1.56239021,3.06726912 1.49769,3.22302888 1.58874955,3.31289028 L2.9654262,4.68237802 C3.02173934,4.73869116 3.11160074,4.73869116 3.16791389,4.68237802 L4.54459054,3.31289028 C4.63565009,3.22183073 4.57094988,3.06726912 4.44274762,3.06726912 L3.594456,3.06726912 L3.594456,1.6774128 C3.594456,1.59833477 3.52975579,1.53363456 3.45067776,1.53363456 L2.68386048,1.53363456 C2.60478245,1.53363456 2.54008224,1.59833477 2.54008224,1.6774128 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAltCircleDown);
export default __webpack_public_path__ + "static/media/arrow-alt-circle-down.5fe876cece40a25b657b38d1e3028741.svg";
export { ForwardRef as ReactComponent };